module.exports = __webpack_public_path__ + "static/pixels-banner-37ce3190e0e6119dd3d4554a4563005a.jpg";